import styled from 'styled-components'
import { colors } from '../../utils/colors'

export const FullPage = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 40px 3%;

  @media screen and (max-width: 1099px) {
    padding-top: 16px;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;
`

export const TitlePage = styled.p`
  font-size: 44px;
  font-weight: 700;
  color: ${colors.main};
  line-height: 1;

  @media screen and (max-width: 1099px) {
    font-size: 34px;
  }
`

export const Subtitle = styled.span`
  display: block;
  margin-top: 8px;
  color: ${colors.third};
  font-size: 14px;
`

export const FilterBar = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 14px 16px;
  padding: 16px;
  background: #fff;
  border: 1px solid ${colors.fourth};
  border-radius: 8px;
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.second};
`

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`

export const KpiCard = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  background: #fff;
  border: 1px solid ${colors.fourth};
  border-radius: 8px;
`

export const KpiIcon = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: ${colors.main};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const KpiValue = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: ${colors.main};
  line-height: 1.1;
  word-break: break-word;
`

export const KpiLabel = styled.div`
  font-size: 13px;
  color: ${colors.third};
  margin-top: 4px;
`

export const KpiHint = styled.div`
  font-size: 11px;
  color: ${colors.third};
  margin-top: 2px;
`

export const ChartGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;

  @media screen and (max-width: 1099px) {
    grid-template-columns: 1fr;
  }
`

export const ChartCard = styled.div<{ span?: number }>`
  grid-column: span ${p => p.span ?? 4};
  background: #fff;
  border: 1px solid ${colors.fourth};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 320px;
  min-width: 0;

  @media screen and (max-width: 1099px) {
    grid-column: span 1;
  }
`

export const ChartTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.main};
  margin: 0;
`

export const ChartBody = styled.div<{ scroll?: boolean }>`
  flex: 1;
  min-height: 240px;
  position: relative;
  ${p => p.scroll && 'max-height: 300px; overflow-y: scroll; overflow-x: hidden; padding-right: 6px;'}

  /* barra sempre visível (o macOS esconde a barra padrão até rolar) */
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${colors.fourth};
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`

export const ClientesControles = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;

  .MuiToggleButton-root {
    text-transform: none;
    padding: 4px 10px;
    font-size: 13px;
  }
  .MuiSelect-select {
    font-size: 13px;
    padding-top: 6px;
    padding-bottom: 6px;
  }
`

export const ClientesResumo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 14px;
  font-size: 12px;
  color: ${colors.second};
`

export const Marcador = styled.i<{ cor: string }>`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 4px;
  background: ${p => p.cor};
`

export const ClienteLinha = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 170px) minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
`

export const ClienteNome = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  font-size: 12px;

  a {
    color: ${colors.second};
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  a:hover {
    color: ${colors.main};
    text-decoration: underline;
  }
  span {
    color: ${colors.third};
    font-size: 11px;
  }
`

export const ClienteBarra = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 16px;
  font-size: 11px;
  color: ${colors.second};
  white-space: nowrap;
`

/* a largura reserva espaço para o valor escrito ao lado da barra */
export const ClienteBarraValor = styled.i<{ cor: string; proporcao: number }>`
  display: block;
  height: 8px;
  border-radius: 0 4px 4px 0;
  background: ${p => p.cor};
  width: calc((100% - 96px) * ${p => p.proporcao});
  min-width: ${p => (p.proporcao > 0 ? 2 : 0)}px;
`

export const MostrarMais = styled.button`
  display: block;
  width: 100%;
  margin-top: 8px;
  padding: 8px;
  background: none;
  border: 1px dashed ${colors.fourth};
  border-radius: 6px;
  color: ${colors.second};
  font-size: 12px;
  cursor: pointer;

  &:hover {
    border-color: ${colors.third};
    color: ${colors.main};
  }
`

export const Empty = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.third};
  font-size: 14px;
`

export const LoadingOverlay = styled.div`
  position: fixed;
  top: 16px;
  right: 24px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: #fff;
  border: 1px solid ${colors.fourth};
  border-radius: 20px;
  font-size: 13px;
  color: ${colors.second};
`
